import { isFunction } from "lodash";
export const run = (fn) => fn();
export const mutate = (item, mutate) => {
    mutate(item);
    return item;
};
export const resolveThunk = (input) => {
    if (isFunction(input))
        return input();
    return input;
};
export const interceptErr = (fn, wrapErr) => {
    try {
        return fn();
    }
    catch (e) {
        throw wrapErr(e);
    }
};
export const interceptErrAsync = async (fn, wrapErr) => {
    try {
        return await fn();
    }
    catch (e) {
        throw wrapErr(e);
    }
};
export const isCtor = (f) => f.prototype && f.prototype.constructor === f;
export const initWith = (initor, params) => {
    if (isCtor(initor)) {
        // eslint-disable-next-line new-cap
        return new initor(...params);
    }
    return initor(...params);
};
export const todo = () => {
    throw new Error("Not yet implemented");
};
export const override = () => {
    throw new Error("Expected this implementation to be overriden");
};
export const unreachable = () => {
    throw new Error("Expected this branch to be unreachable");
};
export function thru(val, handle) {
    return handle(val);
}
export function tap(val, handle) {
    handle(val);
    return val;
}
export async function tapAsync(val, handle) {
    await handle(val);
    return val;
}
export async function pipeAsync(val, ...fns) {
    let res = val;
    for (const fn of fns) {
        // biome-ignore lint/suspicious/noExplicitAny: Implementation uses any, but external signature is type-safe
        res = await fn(res);
    }
    return res;
}
export function pipe(val, ...fns) {
    let res = val;
    for (const fn of fns) {
        // biome-ignore lint/suspicious/noExplicitAny: Implementation uses any, but external signature is type-safe
        res = fn(res);
    }
    return res;
}
//# sourceMappingURL=function.js.map